import { Icon } from "@vds/icons";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Body, Title } from "@vds/typography";

import PropTypes from "prop-types";

const DeleteShipmentModal = (props) => {
  const {
    message,
    title,
    onConfirm,
    onExit,
    setShowDeleteShip,
    showDeleteship,
  } = props;
  return (
    <Modal
      opened={showDeleteship}
      disableOutsideClick={true}
      ariaLabel={`${title} Modal`}
      surface="light"
      fullScreenDialog={false}
      hideCloseButton={true}
      disableAnimation={false}
      onClose={setShowDeleteShip}
      width={"700px"}
      closeButton={
        <button
          style={{
            cursor: "pointer",
            position: "absolute",
            right: "25px",
            top: "25px",
            backgroundColor: "transparent",
            border: "none",
          }}
          onClick={onExit}
        >
          <Icon name="close" />
        </button>
      }
      {...props}
    >
      <ModalTitle>
        <Title size="large">{title}</Title>
      </ModalTitle>
      <ModalBody>
        <Body size="large">
          {message || "Are you sure you want to delete the Shipment"}
        </Body>
      </ModalBody>
      <ModalFooter
        buttonData={{
          close: {
            width: "100%",
            children: "Yes, delete",
            onClick: onConfirm,
          },
          primary: {
            children: "No, cancel",
            width: "100%",
            onClick: onExit,
          },
        }}
      />
    </Modal>
  );
};

DeleteShipmentModal.propTypes = {
  title: PropTypes.any.isRequired,
  message: PropTypes.any.isRequired,
  showDeleteship: PropTypes.bool.isRequired,
  setShowDeleteShip: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onExit: PropTypes.func.isRequired
}

export default DeleteShipmentModal;
